'use strict';

/**
 *
 * @name: sortDropdown
 *
 */

import DirectiveTemplate from './nn-sort-dropdown.directive.html';

function SortDropdownDirective() {

  'ngInject';

  return {
    restrict: 'EA', // TODO: leave only Element
    replace: true,
    template: DirectiveTemplate,
    scope: {
      fields: '&',
      sortBy: '=',
      queryActive: '=',
      descText: '@'
    },
    link: function(scope, element, attrs) {

      scope.sortingFields = scope.fields();

      scope.changeSorting = function(index) {
        scope.sortBy = scope.sortingFields[index];
      };

      if (attrs.contact) {

        scope.attrs = {
          contact: true
        };
      }

      if (attrs.settingsPage) {

        scope.attrs = {
          settingsPage: true
        };
      }

      if (scope.queryActive) {

        scope.$watch('queryActive', function(newVal) {

          if (newVal && scope.sortBy.exclude.indexOf(newVal) > -1) {

            scope.sortBy = scope.sortingFields[0];
          }
        });
      }
    }
  };
}

export default SortDropdownDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/DEPRECATED-nn-sort-dropdown/nn-sort-dropdown.directive.js